var SENTRY_RELEASE;SENTRY_RELEASE={name: "GearSync", version: "0.1.0"};